/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { inputCheckIOS } from '@/utils/common';
import Vue from 'vue';
export default {
  directives: {},
  components: {},
  data: function data() {
    return {
      showAgreement: false,
      btnActive: false,
      account: '',
      password: '',
      showPassword: true
    };
  },
  watch: {
    account: function account(n, o) {
      this.account = n;
      this.btnActive = this.account ? this.password ? 'true' : false : false;
    },
    password: function password(n, o) {
      this.password = n;
      this.btnActive = this.account ? this.password ? 'true' : false : false;
    }
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    login: function login() {
      var _this = this;
      var param = {
        account: this.account,
        password: this.password
      };
      this.$vux.loading.show();
      this.$store.dispatch('Login', param).then(function () {
        _this.$vux.loading.hide();
        Vue.$vux.toast.show({
          text: '登录成功',
          type: 'success',
          time: 2 * 1000
        });
        // 登录成功后重定向到首页
        _this.$router.push({
          path: '/'
        });
      }).catch(function (err) {
        _this.$vux.loading.hide();
        _this.$message.error(err); // 登录失败提示错误
      });
    },
    checkIOS: function checkIOS() {
      // alert('checkIOS')
      inputCheckIOS();
    },
    checkPassword: function checkPassword() {
      this.showPassword = !this.showPassword;
    }
  }
};